import { defineComponent as r, createBlock as p, openBlock as m, unref as l, withCtx as n, createTextVNode as c } from "vue";
import { useResponses as i } from "../hooks/useResponses.js";
import f from "./ParameterList.vue.js";
const h = /* @__PURE__ */ r({
  __name: "OperationResponses",
  props: {
    responses: {},
    collapsableItems: { type: Boolean, default: !0 },
    schemas: {},
    breadcrumb: {}
  },
  setup(o) {
    const t = o, { responses: a } = i(t.responses);
    return (e, s) => (m(), p(f, {
      collapsableItems: e.collapsableItems,
      parameters: l(a),
      schemas: e.schemas,
      withExamples: !1
    }, {
      title: n(() => s[0] || (s[0] = [
        c("Responses")
      ])),
      _: 1
    }, 8, ["collapsableItems", "parameters", "schemas"]));
  }
});
export {
  h as default
};
